import { ExternalAttachmentTypeEnum, ThumbnailAttachmentTypeEnum, UploadAttachmentTypeEnum } from '@onArte/shared/enums/common/attachments';

export enum AttachmentTypeEnum {
  YoutubeVideo = ExternalAttachmentTypeEnum.YoutubeVideo,
  VimeoVideo = ExternalAttachmentTypeEnum.VimeoVideo,
  EventCoverPhoto = UploadAttachmentTypeEnum.EventCoverPhoto,
  ItemPhoto = UploadAttachmentTypeEnum.ItemPhoto,
  ItemCertificate = UploadAttachmentTypeEnum.ItemCertificate,
  ItemSignature = UploadAttachmentTypeEnum.ItemSignature,
  CollectionPhoto = UploadAttachmentTypeEnum.CollectionPhoto,
  PublicProfileAvatar = UploadAttachmentTypeEnum.PublicProfileAvatar,
  PublicProfileCoverPhoto = UploadAttachmentTypeEnum.PublicProfileCoverPhoto,
  PublicProfileGalleryPhoto = UploadAttachmentTypeEnum.PublicProfileGalleryPhoto,
  SliderPhoto = UploadAttachmentTypeEnum.SliderPhoto,
  ThumbnailSize_100x100 = ThumbnailAttachmentTypeEnum.Size_100x100,
  ThumbnailBigSize_340xAuto = ThumbnailAttachmentTypeEnum.Size_340xAuto,
}
